import getCurrentPeriod from "./get-current-period";
import matchCurrentVolume from "./match-current-volume";

export default function matchCurrentSeason(parentVolume, { state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  const currentVolume = matchCurrentVolume({ state, getters });

  // We only want the current season if the selected volume is also
  // the current volume. If the selected volume is not the current
  // volume, then `autoSeason` fall back to the first
  // season of the selected volume.
  if (!currentVolume || currentVolume !== parentVolume) {
    return null;
  }

  // If the selected volume is the current volume, return the season
  // which the current date falls into.
  return getCurrentPeriod(currentVolume.seasons);
}
